export default __webpack_public_path__ + "static/media/ic_twotone-rss-feed.e0c7febf.svg";